import type { RouteObject } from 'react-router';

import { PATHNAMES } from 'constants/constants';
import { lazyRoute } from 'utils/lazyRoute';

const OfficeActions = lazyRoute(
  () => import('pages/OfficeActionsV2/OfficeActions'),
  m => m.OfficeActions,
);

export const officeActionV2Routes: RouteObject[] = [
  { path: PATHNAMES.officeActionsV2New, lazy: OfficeActions },
  { path: PATHNAMES.officeActionsV2, lazy: OfficeActions },
];
